import { useRouter } from 'next/router';

import { Alert } from '@zillow/constellation-10';

import { useReimportLock } from '../../hooks/useReimportLock';
import accessUtils from '../../utils/accessUtils';

/**
 * Per-section heads-up shown while a recent feed-override edit is syncing back to the feed. Client-side only
 * (mirrors the top-level ReimportSyncingBanner) so it survives a refresh and needs no backend lock.
 */
const FeedOverrideSectionSyncingBanner = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;
  const { isReimportLocked } = useReimportLock({ listingAlias });

  if (!isReimportLocked || !accessUtils.canAccessFeedOverrides()) {
    return null;
  }

  return (
    <Alert tone="info" css={{ marginBottom: '400' }}>
      Your recent change is syncing with the feed and may take a few minutes to appear here
    </Alert>
  );
};

export default FeedOverrideSectionSyncingBanner;
